import { useConvertList } from "@/api/services/admin/convert-request";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { TypoLink } from "@/components/elements/TypoLink";
import { CONVERT_STATUS } from "@/constants/enum";
import { DEFAULT_PER_PAGE, START_PAGE } from "@/constants/pagination";
import { ConvertListPagination } from "@/features/convert/component/ConvertListPagination";
import { ConvertTable } from "@/features/convert/component/ConvertTable";
import { useConvertFilterCache } from "@/features/convert/provider/ConvertListFilterCacheProvider";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";

export const ConvertListPage = () => {
  const { convertFilterCache } = useConvertFilterCache();

  const { data: convertListResult, isLoading } = useConvertList({
    status: [CONVERT_STATUS.IN_PROGRESS],
    sorts: ["convertRequest.createdAt|ASC"],
    page: convertFilterCache?.page || START_PAGE,
    perPage: DEFAULT_PER_PAGE,
  });

  if (isLoading) return <LoadingPage />;

  return (
    <>
      <TopPage title="提出形式の変換依頼一覧" enablePageBack={false} />
      <Stack gap={2}>
        <ConvertListPagination totalPage={convertListResult?.pagination.totalPage} />
        {convertListResult && <ConvertTable isLoading={isLoading} data={convertListResult ?? []} />}
        <TypoLink to={AppRoutes.convertHistory}>過去処理分の一覧へ</TypoLink>
      </Stack>
    </>
  );
};
